<template>
  <ml-input v-if="readonly" :value="Array.isArray(data) ? data.map( value => $t(value) ).join(', ') : $t(data.replaceAll('직접입력_', '').replaceAll('직접 입력_', '')) || ''" style="color: red" readonly class="w-full flex-1" />
  <div v-else-if="multiple">
    <multiselect :options="disasterList" v-model="data" :multiple="true" placeholder="" openDirection="below">
      <template #tag="{ option, remove }">
        <span class="multiselect__tag">
          <span>{{ $t(option) }}</span> <i tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
        </span>
      </template>

      <template #option="props">
        <span>{{ $t(props.option) }}</span>
      </template>
    </multiselect>
    <ml-input v-if="isCustomData" v-model="customDisasterData" class="mt-2 w-full" :placeholder="$t('직접입력')" />
  </div>
  <div v-else>
    <vs-select v-model="disasterData" autocomplete :disabled="disabled || readonly" class="w-full red-text disaster">
      <vs-select-item v-for="disaster in disasterList" :key="disaster" :value="disaster" :text="$t(disaster)" />
    </vs-select>
    <ml-input v-if="isCustomData" v-model="customDisasterData" class="mt-2 w-full" :placeholder="$t('직접입력')" />
  </div>
</template>

<script>
/* eslint-disable brace-style */
import { disasters, disasters_안전_정기위험성평가, disasters_보건_정기위험성평가 } from "@/util/DisasterDataUtil.js";
import Multiselect from "vue-multiselect";
export default {
  name: "DisasterClassSelector",
  components: {
    Multiselect,
  },
  props: {
    /**
     * @param {String|Array} value - 선택된 재해형태 (String: 단일선택, Array: 다중선택)
     */
    value: {
      type: [String, Array],
      default: "",
    },
    listKey: {
      type: "normal" | "safety" | "health",
      default: "normal",
    }, // disasters | disasters_안전_정기위험성평가 | disasters_보건_정기위험성평가
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
  },
  computed: {
    isCustomData() {
      return this.data && this.data.indexOf("직접입력") >= 0;
    },
    disasterData: {
      get() {
        if (this.data.indexOf("직접입력") >= 0) {
          return "직접입력";
        } else {
          return this.data;
        }
      },
      set(value) {
        this.data = value;
      },
    },
    customDisasterData: {
      get() {
        if (this.data.indexOf("직접입력") >= 0) {
          // _ 기호로 분할해서, [1] 번째 아이템을 반환한다
          return this.data.split("_")[1];
        } else {
          return "";
        }
      },
      set(value) {
        this.data = `직접입력_${value}`;
      },
    },
  },
  data() {
    return {
      disasterList: disasters,
      data: this.value,
      selected: "",
    };
  },
  watch: {
    /**
     * 이 컴포넌트의 v-model 값이 업데이트 됐을 때 실행되는 함수
     * @param value
     */
    value(value) {
      if (this.multiple) {
        const list = [];
        if (value && value.length > 0) {
          for (const item of value) {
            // 만약 저장된 데이터가 disasters에 없다면, 직접입력된 항목이다.
            if (disasters.indexOf(item) === -1) {
              // 만약 "직접입력_" 텍스트가 포함되어 있다면, 그대로 저장한다.
              if (item.indexOf("직접입력_") >= 0) {
                list.push(item);
              }
              // 그렇지 않다면, "직접입력_" 텍스트를 추가해서 저장한다.
              else {
                list.push(`직접입력_${item}`);
              }
            }
            // disasters에 있는 항목이라면, 그대로 저장한다.s
            else {
              list.push(item);
            }
          }
        }

        if (JSON.stringify(this.data) !== JSON.stringify(list)) {
          this.$set(this, "data", list);
        }
        return;
      }

      // 단일 선택일 경우
      // 만약 저장된 데이터가 disasters에 없다면, 직접입력된 항목이다.
      if (disasters.indexOf(value) === -1) {
        // 만약 "직접입력_" 텍스트가 포함되어 있다면, 그대로 저장한다.
        if (value.indexOf("직접입력_") >= 0) {
          this.$set(this, "data", value);
        }
        // 그렇지 않다면, "직접입력_" 텍스트를 추가해서 저장한다.
        else {
          this.$set(this, "data", `직접입력_${value}`);
        }
      }
      // disasters에 있는 항목이라면, 그대로 저장한다.
      else {
        this.$set(this, "data", value);
      }
    },
    customData() {
      console.log("customData", this.customData);
      this.emitInput();
    },
    data(value) {
      this.emitInput();
    },
  },
  created() {
    if (this.listKey === "safety") {
      this.disasterList = disasters_안전_정기위험성평가;
    } else if (this.listKey === "health") {
      this.disasterList = disasters_보건_정기위험성평가;
    }
  },
  mounted() {},
  methods: {
    emitInput() {
      if (this.multiple) {
        const list = [];
        if (this.data && this.data.length > 0) {
          for (const data of this.data) {
            if (data === "직접입력") {
              list.push(this.customData);
            } else {
              list.push(data);
            }
          }
        }

        this.$emit("input", list);
      } else {
        // if (this.data === "직접입력") {
        //   this.$emit("input", this.customData);
        // } else {
        //   this.$emit("input", this.data);
        // }
        this.$emit("input", this.data);
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.red-text.disaster input {
  color: red;
}
</style>
<style lang="scss">
.multiselect {
  .multiselect__tags {
    .multiselect__tag {
      background-color: rgba(var(--vs-secondary), 1) !important;
    }
    .multiselect__tag-icon::after {
      color: rgb(30, 13, 97);
    }
    border-color: #cdcdcd !important;
  }
}
</style>
